<template>
  <div class="layout-container">
      <el-tabs type="border-card">
          <el-tab-pane label="经纪人列表">
              <div style="background: #ffffff;position:relative;">
                  <div class="search-condition-con show" >
                    <div class="search-condition">
                        <span class="label">站点</span>
                        <div class="input-condition">
                            <site-auto-complete 
                                v-model="condition.site_id"
                                :clueId="1"
                                :init-choose-first="true"
                                :owned="true"
                                ref="siteAutoComplete"
                                @created="initData" 
                                clearable>
                            </site-auto-complete>
                        </div>
                    </div>
                    <div class="search-condition">
                        <span class="label">代理商</span>
                        <div class="input-condition">
                            <business-auto-complete v-model="condition.company_id" clearable></business-auto-complete>
                        </div>
                    </div>
                   
                    <div class="search-condition">
                        <span class="label">经纪人姓名</span>
                        <div class="input-condition">
                            <el-input v-model="condition.name" maxlength="20" placeholder="请输入经纪人姓名"></el-input>
                        </div>
                    </div>    
                    <div class="search-condition">
                        <span class="label">经纪人账号</span>
                        <div class="input-condition">
                            <el-input v-model="condition.account" maxlength="20" placeholder="请输入经纪人账号"></el-input>
                        </div>
                    </div>    
                  </div>
                  <div class="btn-condition">
                      <el-button type="primary" @click="handleSearch()">查 询</el-button>
                      <el-button  @click="resetSearch()">清空条件</el-button>
                  </div>
              </div>
              <div>
                <el-table
                        :data="list"
                        style="width: 100%"
                        :highlight-current-row="true"
                        stripe
                        tooltip-effect="dark"
                        ref="multipleTable"
                        v-loading="isLoading"
                        header-cell-class-name="table-back"
                >
                    <el-table-column  label="站点" prop="select_site_name"></el-table-column>
                    <el-table-column  label="经纪人姓名" prop="name"></el-table-column>
                    <el-table-column  label="经纪人账号" prop="account"></el-table-column>
                    <el-table-column  label="联系方式" prop="main_tel"></el-table-column>
                    <el-table-column  label="商户名称" prop="main_tel" align="center">
                        <template slot-scope="scope">
                            <p  v-if="scope.row.is_seat_account == 0"> <span style="background: #ddd;padding: 0px 10px;border-radius: 15px;">非坐席账号</span></p>
                            <p>{{scope.row.company_name}}</p>
                        </template>
                    </el-table-column>
                    <el-table-column  label="入驻状态" prop="status_str"></el-table-column>
                    <el-table-column label="绑定楼盘数" align="center">
                        <template slot-scope="scope">
                            <span style="color: #409eff;cursor: pointer;" @click="checkHouseData(scope.row)">查看</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center">
                        <template slot="header">
                        <span style="color: #409eff">操作</span>
                        </template>
                        <template slot-scope="scope">
                        <el-button
                            size="mini"
                            v-if="scope.row.is_seat_account == 0"
                            @click="setAccount(scope.row)"
                            v-permission="'business.broker.list'"
                            >设为坐席账号</el-button
                        >
                        </template>
                    </el-table-column>
                </el-table>
                <template v-if="list.length > 0">
                    <el-pagination background layout="total,prev, pager, next" :current-page="condition.page"  :total="condition.total" :page-size="condition.per_page" @current-change="currentChange"></el-pagination>
                </template>
              </div>
          </el-tab-pane>
      </el-tabs>
      <el-dialog
            title="设为坐席账号"
            :visible.sync="dialogAccVisible"
            width="30%"
            :before-close="handleClose2">
            <div class="setAcc">
                <p>是否确认设为坐席账号？</p>
                <p>提示：</p>
                <p>1、同一经纪人存在于不同商户，只能有一个商户下的账号可以设置为坐席账号，其他商户下该经纪人的账号为非坐席账号；</p>
                <p>2、只有坐席账号才能绑定楼盘、400、IM。</p>
                <p>3、更改坐席账号后，原坐席，将会自动变更为更改后坐席账号。</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogAccVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmSetAcc">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
            :title="checkHouseTitle"
            :visible.sync="dialogHouseVisible"
            width="30%"
            :before-close="handleClose1">
            <div class="setAcc">
                <p>绑定楼盘数：{{ housesNum }}</p>
                <div class="detail">
                    <p style="word-break: keep-all;">绑定楼盘明细：</p>
                    <p>{{ houseStr.length ? houseStr : '无' }}</p>
                </div>
               
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogHouseVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogHouseVisible = false">确 定</el-button>
            </span>
        </el-dialog>
  </div>
</template>

<script>
  import { getBrokersList,getBrokerHousesList,setBrokerAccount} from '@/service/broker'
  import businessAutoComplete from '@/components/auto-complete/business-auto-complete'
  import SiteAutoComplete from "@/components/auto-complete/site-auto-complete";  

  export default {
    name: 'BrokerList',
      components: {
        SiteAutoComplete,
        businessAutoComplete,
      },
      data () {
          return {
              condition: {
                site_id:'',
                company_id:'',
                name:'',
                account:'',
                total : 0,
                per_page : 10,
                page : 1,
              },
              isLoading: false,
              list: [],
              dialogAccVisible:false,
              dialogHouseVisible:false,
              checkHouseTitle:'',
              housesNum:'3',
              houseStr:'',
              ActiveId:null,
              ActiveCompanyId:null
          }
      },
      methods: {

          handleSearch() {
              this.condition.page = 1;
              this.initData()
          },
          resetSearch() {
            this.condition = {
                site_id:null,
                company_id:'',
                name:'',
                account:'',
                total : 0,
                per_page : 10,
                page : 1,
            };
            this.$nextTick(() => {
                this.$refs.siteAutoComplete && this.$refs.siteAutoComplete.reset();
            });
          },

          async initData () {
              let query = this.condition;
              this.isLoading = true;
              await getBrokersList(query).then((data) => {
                  this.condition.total= parseInt(data.total);
                  this.condition.per_page = parseInt(data.per_page);
                  this.list = data.data
              });
              this.isLoading = false;
          },
          currentChange (index) {
              this.condition.page = index;
              this.initData()
          },
         async checkHouseData(row){
            this.checkHouseTitle = '【'+row.company_name+'】-【'+ row.name +'】'
            let query = {};
            query.crm_id = row.id
            query.site_id = this.condition.site_id
            await getBrokerHousesList(query).then((data) => {
               let house = data.data.length ? data.data.map( item => item.name) : []
               this.housesNum = house.length
               this.houseStr = house.join('、')
                
            });
            this.dialogHouseVisible = true
          },
          setAccount(row){
            this.ActiveId = row.id
            this.ActiveCompanyId = row.company_id
            this.dialogAccVisible = true

          },
          async confirmSetAcc(){
            let query = {};
            query.crm_id = this.ActiveId
            query.company_id = this.ActiveCompanyId
            await setBrokerAccount(query).then((data) => {
                this.$message({
                    message: data.message,
                    type: 'success',
                    duration: 3 * 1000
                });
                this.dialogAccVisible = false
            });
          },
          handleClose1(){
            this.dialogHouseVisible = false;
          },
          handleClose2(){
            this.dialogAccVisible = false;
          }
      }
  }
</script>
<style scope>
    .el-dialog__body{
        padding:10px 20px;
    }
    .setAcc p{
        line-height: 30px;
    }
    .setAcc .detail{
        display: flex;
    
    }
</style>